export const removeViewerPlaceholder = () => {
    const viewerPlaceholder: HTMLElement | null = document.querySelector('#viewerPlaceholder');
    if (viewerPlaceholder) {
        viewerPlaceholder.style.display = 'none';
    }
};
